import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { getHomePage } from "../services/HomePageService";

// Create context
const HomeDataContext = createContext();

// Provider
export const HomeDataProvider = ({ children }) => {
  const { data: homeData, isLoading: loading, refetch: refreshHomeData } = useQuery({
    queryKey: ["homeData"],
    queryFn: async () => {
      const res = await getHomePage();
      if (res?.data?.success) {
        return res.data.data;
      }
      return null;
    },
  });

  return (
    <HomeDataContext.Provider
      value={{
        homeData,
        loading,
        refreshHomeData,
      }}
    >
      {children}
    </HomeDataContext.Provider>
  );
};

// Custom Hook
export const useHomeData = () => {
  return useContext(HomeDataContext);
};
